import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

// import LinkNewsletter from "./../../Components/LinkNewsletter";

export class NoticiaDetalhe extends Component {
  state = {
    noticia: {},
  };

  abortController = new AbortController();

  componentDidMount() {
    axios
      .get(
        `https://ipbnews.ipb.pt/submissao/index.php?r=submissao/json&id=${this.props.match.params.id}`
      )
      .then((res) => res.data.map((noticia) => this.setState({ noticia })))
      .catch((err) => {
        console.log("error", err.name);
        if (err.name === "AbortError") return;
        throw err;
      });
  }

  componentWillUnmount() {
    this.abortController.abort();
  }

  render() {
    let { noticia } = this.state;
    return (
      <React.Fragment>
        {/* <LinkNewsletter /> */}
        <div className="notContainer">
          <div className="noticiaConteudo">
            <div className="conteudoTop">
              <img
                src={`https://ipbnews.ipb.pt/submissao/uploads/${noticia.foto}`}
                alt="NoticiaImg"
              />
              <div>
                <span>
                  {new Date(noticia.data).toLocaleDateString("pt-PT", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })}
                </span>
                <p>{noticia.titulo}</p>
              </div>
            </div>
            <div className="conteudoDesc">
              <p id="resumo">{noticia.resumo}</p>
              <p dangerouslySetInnerHTML={{__html: noticia.texto}}></p>
            </div>
          </div>
          <div className="btnVoltar">
            <Link to="/noticias">Voltar</Link>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default NoticiaDetalhe;
